<template>
 <div class="overlay">
          <div class="Wrap display-flex">
       <div class="image">
           <img src="../assets/popup-img.svg" alt="">
       </div>
       <div class="wm100">
           <h1>Stay tuned!</h1>
           <p>Get the latest articles and business updates that you need to know,
                you’ll get updates straight from our desktop to your inbox</p>

            <div class="btn">
                <router-link to="/">
                    <button @click="closePopUp">Home</button>
                </router-link>
                
            </div>
       </div>
   </div>
 </div>
</template>

<script>
export default {
name: 'Popup',
methods:{
    closePopUp(){
        this.$emit('closePopMessage')
    }
}
}
</script>

<style lang="scss" scoped>
.overlay{
    height:110vh;
    position: fixed;
    left: 0px;
     z-index:300;
      backdrop-filter: brightness(0.3);
    width: 100%;
    top: 0px;
    .Wrap{
    width:70%;
    background: white;
    border-radius: 20px;
    transform: translateY(25%);
    margin:0 auto;
    padding:25px 20px;
    font-family: 'DM sans', sans-serif;
    .image{
        width:48%;
        img{
            width:100%
        }
    }
    .wm100{
        width:50%;
        h1{
            color: #394452;
            margin-bottom: 20px;
        }
        p{
        margin:10px 0px;
          font-size: 1em;
          line-height: 23px;
          color: #394452;
        }
          .btn{
        margin-top:20px;
        a{
            text-decoration: none;
        }
        button{
            color: white;
            font-size:18px;
            background-color: #AB0519;
            width: 100%;
            font-weight:500;
            padding:17px;
            border-radius: 10px;
            outline: none;
            border: none;
        }
    }
    }
}
}
@media (max-width:600px){
    .overlay{
        .Wrap{
            width:85%;
            padding:25px 25px;
            .image{
                width:80%;
            }
             .wm100{
               width:90%;
            }
       }
    }
}
@media (max-width:400px){
    .overlay{
        .Wrap{
            width:90%;
            padding:25px 25px;
            .image{
                width:90%;
            }
             .wm100{
               width:100%;
            }
       }
    }
}
</style>